import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { LogIn } from "lucide-react";
import AuthShell from "@/components/app/AuthShell";

export default function LoginPage() {
  const { login, formatApiError } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      nav(location.state?.from || "/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell icon={LogIn} tint="bg-sakura/40" title={t("welcomeBackTitle")} subtitle={t("signInSave")} testId="login-card"
      footer={<>
        <div>{t("noAccount")} <Link to="/register" className="underline font-extrabold text-ink">{t("signup")}</Link></div>
        <div>{t("preferSkip")} <Link to="/learn/hiragana" className="underline font-extrabold text-ink">{t("learnGuest")}</Link></div>
      </>}>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="login-email" type="email" required placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value)} className="kawaii-input" />
        <input data-testid="login-password" type="password" required placeholder={t("password")} value={password} onChange={(e) => setPassword(e.target.value)} className="kawaii-input" />
        {error && <div data-testid="login-error" className="kawaii-chip !bg-coral/60 !text-sm !py-2 !px-4 w-full">{error}</div>}
        <button data-testid="login-submit" disabled={busy} className="kawaii-btn kawaii-btn-primary w-full !py-3.5">{busy ? "…" : t("login")}</button>
      </form>
    </AuthShell>
  );
}
